export default "__VITE_ASSET__VJGAT7Di__"